// extracted by mini-css-extract-plugin
module.exports = {"chipGroup":"ChipSelect_chipGroup__Pm2M8"};